// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1-Nm8","filesListContainer":"PosDisputesFiles_filesListContainer__MYEYU","filesButton":"PosDisputesFiles_filesButton__2bnUW"};